

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   Checkbox,
//   FormControlLabel,
//   Link,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   useTheme,
//   useMediaQuery,
// } from '@mui/material';
// import { Visibility, VisibilityOff, Mail, Lock, Height } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import LogoImage from '../landpageimage/logo1.png'; // Replace with your logo path
// import FloatingIllustration from '../landpageimage/logo2.jpg';

// // Define theme colors based on the logo
// const themeColors = {
//   primary: '#00A76F', // Green
//   secondary: '#2196F3', // Blue
//   accent: '#FF7043', // Orange
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
// };

// const Logo = styled('img')({
//   height: '40px',
//   marginBottom: '24px',
// });

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   position: 'relative',
//   width: '100%',
//   maxWidth: '1200px',
//   margin: '20px',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   display: 'flex',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
//   [theme.breakpoints.down('md')]: {
//     margin: '16px',
//   },
// }));

// const FormSection = styled(Box)(({ theme }) => ({
//   flex: '1',
//   padding: '48px',
//   display: 'flex',
//   flexDirection: 'column',
//   gap: '24px',
//   backgroundColor: '#fff',
//   zIndex: 1,
//   [theme.breakpoints.down('sm')]: {
//     padding: '32px 24px',
//   },
// }));

// const WelcomeSection = styled(Box)(({ theme }) => ({
//   flex: '1',
//   padding: '48px',
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'center',
//   alignItems: 'center',
//   background: themeColors.gradient,
//   position: 'relative',
//   overflow: 'hidden',
//   [theme.breakpoints.down('md')]: {
//     display: 'none',
//   },
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     transition: 'all 0.2s ease-in-out',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused': {
//       backgroundColor: '#F9FAFB',
//       '& fieldset': {
//         borderColor: themeColors.primary,
//         borderWidth: '2px',
//       },
//     },
//   },
//   '& .MuiInputLabel-root.Mui-focused': {
//     color: themeColors.primary,
//   },
// }));

// const SignInButton = styled(Button)(({ theme }) => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '14px',
//   borderRadius: '16px',
//   textTransform: 'none',
//   fontSize: '16px',
//   fontWeight: 600,
//   transition: 'all 0.2s ease-in-out',
//   '&:hover': {
//     backgroundColor: '#008F5D',
//     transform: 'translateY(-2px)',
//     boxShadow: '0 8px 16px rgba(0, 167, 111, 0.2)',
//   },
// }));

// const FloatingImage = styled('img')({
//   position: 'absolute',
//   width: '100%',
//   maxWidth: '400px',
//   height: 'auto',
//   zIndex: 1,
// });

// export default function Login() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     email: '',
//     password: '',
//   });
//   const [error, setError] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };


//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/login/', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         const { access, role, email: userEmail, user_id } = data;
//         localStorage.setItem('authToken', `Bearer ${access}`);
//         localStorage.setItem('userEmail', userEmail);
//         localStorage.setItem('user_id', user_id);

//         switch (role) {
//           case 'Student':
//             navigate('/StudentApp/');
//             break;
//           case 'Investor':
//             navigate('/InvestorApp/');
//             break;
//           case 'Admin':
//             navigate('/AdminApp/');
            
//             break;
//           default:
//             navigate('/AdminApp/');
           
//         }
//       } else {
//         setError(data.message || 'Login failed. Please check your credentials.');
//       }
//     } catch (err) {
//       setError('An error occurred. Please try again later.');
//       console.error('Login error:', err);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundColor: '#F3F4F6',
//         padding: { xs: '16px', sm: '24px' },
//         background: 'linear-gradient(135deg, #E6F7F1 0%, #E3F2FD 100%)',
//       }}
//     >
//       <StyledPaper>
//         <FormSection>
//           <Box>
//           <Logo src={LogoImage} alt="Company Logo" style={{ width: '150px', height: 'auto' }} />

//             <Typography 
//               variant="h3" 
//               fontWeight="800" 
//               sx={{ 
//                 mb: 1,
//                 background: themeColors.gradient,
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//               }}
//             >
//               Hello!
//             </Typography>
//             <Typography variant="h6" color="text.secondary" fontWeight="500">
//               Welcome back, you've been missed!
//             </Typography>
//           </Box>

//           {error && (
//             <Typography 
//               color="error" 
//               variant="body2" 
//               sx={{ 
//                 p: 2, 
//                 bgcolor: '#FEE2E2', 
//                 borderRadius: 2,
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 1 
//               }}
//             >
//               {error}
//             </Typography>
//           )}

//           <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
//             <StyledTextField
//               fullWidth
//               label="Email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Mail sx={{ color: themeColors.primary }} />
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             <StyledTextField
//               fullWidth
//               label="Password"
//               name="password"
//               type={showPassword ? 'text' : 'password'}
//               value={formData.password}
//               onChange={handleChange}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Lock sx={{ color: themeColors.primary }} />
//                   </InputAdornment>
//                 ),
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowPassword(!showPassword)}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               flexWrap: 'wrap',
//               gap: 1
//             }}>
//               <FormControlLabel
//                 control={
//                   <Checkbox 
//                     sx={{ 
//                       '&.Mui-checked': { 
//                         color: themeColors.primary,
//                       }
//                     }} 
//                   />
//                 }
//                 label={
//                   <Typography variant="body2" color="text.secondary">
//                     Remember me
//                   </Typography>
//                 }
//               />
//               <Link
//                 href="#"
//                 sx={{
//                   color: themeColors.primary,
//                   textDecoration: 'none',
//                   fontWeight: 500,
//                   '&:hover': { 
//                     textDecoration: 'underline',
//                   },
//                 }}
//               >
//                 Forgot password?
//               </Link>
//             </Box>

//             <SignInButton type="submit" fullWidth>
//               Sign in
//             </SignInButton>

//             <Typography 
//               variant="body2" 
//               color="text.secondary" 
//               align="center"
//             >
//               Don't have an account?{' '}
//               <Link
//                 href="/StudentRegister"
//                 sx={{
//                   color: themeColors.primary,
//                   textDecoration: 'none',
//                   fontWeight: 500,
//                   '&:hover': { 
//                     textDecoration: 'underline',
//                   },
//                 }}
//               >
//                 Create one now
//               </Link>
//             </Typography>
//           </form>
//         </FormSection>

//         <WelcomeSection>
//           <Box
//             sx={{
//               position: 'relative',
//               width: '100%',
//               height: '100%',
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: 'white',
//               textAlign: 'center',
//               zIndex: 2,
//             }}
//           >
//             <FloatingImage
//           src={FloatingIllustration}
//               alt="Login illustration"
//               sx={{
//                 animation: 'float 6s ease-in-out infinite',
//                 '@keyframes float': {
//                   '0%, 100%': {
//                     transform: 'translateY(0)',
//                   },
//                   '50%': {
//                     transform: 'translateY(-20px)',
//                   },
//                 },
//               }}
//             />
//             <Typography 
//               variant="h4" 
//               fontWeight="bold" 
//               sx={{ mt: 4, mb: 2 }}
//             >
//               Welcome Back!
//             </Typography>
//             <Typography 
//               variant="body1" 
//               sx={{ 
//                 opacity: 0.9,
//                 maxWidth: '400px',
//               }}
//             >
//               Join our community of innovators and creators. Your next big opportunity awaits!
//             </Typography>
//           </Box>
          
//           {/* Decorative elements */}
//           <Box
//             sx={{
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               opacity: 0.1,
//               background: 'radial-gradient(circle at 30% 107%, #00A76F 0%, transparent 45%)',
//             }}
//           />
//           <Box
//             sx={{
//               position: 'absolute',
//               top: '50%',
//               left: '50%',
//               width: '200%',
//               height: '200%',
//               transform: 'translate(-50%, -50%) rotate(-10deg)',
//               background: 'linear-gradient(45deg, transparent 45%, rgba(255,255,255,0.1) 45%, rgba(255,255,255,0.1) 55%, transparent 55%)',
//             }}
//           />
//         </WelcomeSection>
//       </StyledPaper>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   Checkbox,
//   FormControlLabel,
//   Link,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   useTheme,
//   useMediaQuery,
// } from '@mui/material';
// import { Visibility, VisibilityOff, Mail, Lock } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';

// const themeColors = {
//   primary: '#00A76F',
//   secondary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
// };

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   width: '100%',
//   maxWidth: '1200px',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
//   margin: '20px',
//   display: 'flex',
//   flexDirection: 'column',
//   [theme.breakpoints.down('md')]: {
//     margin: '16px',
//   },
// }));

// const FormSection = styled(Box)(({ theme }) => ({
//   flex: 1,
//   padding: '48px',
//   display: 'flex',
//   flexDirection: 'column',
//   gap: '24px',
//   backgroundColor: '#fff',
//   [theme.breakpoints.down('sm')]: {
//     padding: '32px',
//   },
// }));

// const WelcomeSection = styled(Box)(({ theme }) => ({
//   flex: 1,
//   padding: '48px',
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'center',
//   alignItems: 'center',
//   background: themeColors.gradient,
//   [theme.breakpoints.down('md')]: {
//     display: 'none',
//   },
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused': {
//       backgroundColor: '#F9FAFB',
//       '& fieldset': {
//         borderColor: themeColors.primary,
//         borderWidth: '2px',
//       },
//     },
//   },
//   '& .MuiInputLabel-root.Mui-focused': {
//     color: themeColors.primary,
//   },
// }));

// const SignInButton = styled(Button)(({ theme }) => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '14px',
//   borderRadius: '16px',
//   textTransform: 'none',
//   fontSize: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//     transform: 'translateY(-2px)',
//     boxShadow: '0 8px 16px rgba(0, 167, 111, 0.2)',
//   },
// }));

// export default function Login() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({ email: '', password: '' });
//   const [error, setError] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.email || !formData.password) {
//       setError('Please fill in all fields.');
//       return;
//     }
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/login/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         const { access, role } = data;
//         localStorage.setItem('authToken', `Bearer ${access}`);
//         switch (role) {
//           case 'Student':
//             navigate('/StudentApp/');
//             break;
//           case 'Investor':
//             navigate('/InvestorApp/');
//             break;
//           case 'Admin':
//             navigate('/AdminApp/');
//             break;
//           default:
//             navigate('/');
//         }
//       } else {
//         setError(data.message || 'Login failed. Check your credentials.');
//       }
//     } catch (err) {
//       setError('An error occurred. Please try again later.');
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: 'linear-gradient(135deg, #E6F7F1 0%, #E3F2FD 100%)',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
//           <FormSection>
//             <Typography variant="h4" fontWeight="bold" mb={1}>
//               Welcome Back!
//             </Typography>
//             <Typography variant="body1" color="text.secondary" mb={2}>
//               Sign in to continue to your account.
//             </Typography>
//             {error && (
//               <Typography color="error" variant="body2" mb={2}>
//                 {error}
//               </Typography>
//             )}
//             <form onSubmit={handleSubmit}>
//               <StyledTextField
//                 fullWidth
//                 label="Email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Mail sx={{ color: themeColors.primary }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{ mb: 2 }}
//               />
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Lock sx={{ color: themeColors.primary }} />
//                     </InputAdornment>
//                   ),
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{ mb: 2 }}
//               />
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center',
//                   mb: 2,
//                 }}
//               >
//                 <FormControlLabel
//                   control={<Checkbox />}
//                   label="Remember me"
//                   sx={{ color: themeColors.primary }}
//                 />
//                 <Link href="#" underline="hover" color={themeColors.primary}>
//                   Forgot password?
//                 </Link>
//               </Box>
//               <SignInButton type="submit" fullWidth>
//                 Sign In
//               </SignInButton>
//             </form>
//             <Typography mt={2} align="center" variant="body2">
//               Don’t have an account?{' '}
//               <Link href="/StudentRegister" underline="hover" color={themeColors.primary}>
//                 Sign Up
//               </Link>
//             </Typography>
//           </FormSection>
//           <WelcomeSection>
//             <Typography variant="h4" color="white" fontWeight="bold" mb={2}>
//               Hello Again!
//             </Typography>
//             <Typography variant="body1" color="white" align="center">
//               Join our community of innovators and creators. Your next big opportunity awaits!
//             </Typography>
//           </WelcomeSection>
//         </Box>
//       </StyledPaper>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   Checkbox,
//   FormControlLabel,
//   Link,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   useTheme,
//   useMediaQuery,
// } from '@mui/material';
// import { Visibility, VisibilityOff, Mail, Lock } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';

// const themeColors = {
//   primary: '#00A76F',
//   secondary: '#2196F3',
//   gradient: 'linear-gradient(90deg, transparent, #9333EA, transparent)',
// };

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   width: '100%',
//   maxWidth: '1200px',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
//   margin: '20px',
//   display: 'flex',
//   flexDirection: 'column',
//   [theme.breakpoints.down('md')]: {
//     margin: '16px',
//   },
// }));

// const FormSection = styled(Box)(({ theme }) => ({
//   flex: 1,
//   padding: '48px',
//   display: 'flex',
//   flexDirection: 'column',
//   gap: '24px',
//   backgroundColor: '#fff',
//   [theme.breakpoints.down('sm')]: {
//     padding: '32px',
//   },
// }));

// const WelcomeSection = styled(Box)(({ theme }) => ({
//   flex: 1,
//   padding: '48px',
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'center',
//   alignItems: 'center',
//   background: themeColors.gradient,
//   [theme.breakpoints.down('md')]: {
//     display: 'none',
//   },
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused': {
//       backgroundColor: '#F9FAFB',
//       '& fieldset': {
//         borderColor: themeColors.primary,
//         borderWidth: '2px',
//       },
//     },
//   },
//   '& .MuiInputLabel-root.Mui-focused': {
//     color: themeColors.primary,
//   },
// }));

// const SignInButton = styled(Button)(({ theme }) => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '14px',
//   borderRadius: '16px',
//   textTransform: 'none',
//   fontSize: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//     transform: 'translateY(-2px)',
//     boxShadow: '0 8px 16px rgba(0, 167, 111, 0.2)',
//   },
// }));

// export default function Login() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({ email: '', password: '' });
//   const [error, setError] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.email || !formData.password) {
//       setError('Please fill in all fields.');
//       return;
//     }
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/login/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         const { access, role } = data;
//         localStorage.setItem('authToken', `Bearer ${access}`);
//         switch (role) {
//           case 'Student':
//             navigate('/StudentApp/');
//             break;
//           case 'Investor':
//             navigate('/InvestorApp/');
//             break;
//           case 'Admin':
//             navigate('/AdminApp/');
//             break;
//           default:
//             navigate('/');
//         }
//       } else {
//         setError(data.message || 'Login failed. Check your credentials.');
//       }
//     } catch (err) {
//       setError('An error occurred. Please try again later.');
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: 'linear-gradient(90deg, transparent, #9333EA, transparent)',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
//           <FormSection>
//             <Typography variant="h4" fontWeight="bold" mb={1}>
//               Welcome Back!
//             </Typography>
//             <Typography variant="body1" color="text.secondary" mb={2}>
//               Sign in to continue to your account.
//             </Typography>
//             {error && (
//               <Typography color="error" variant="body2" mb={2}>
//                 {error}
//               </Typography>
//             )}
//             <form onSubmit={handleSubmit}>
//               <StyledTextField
//                 fullWidth
//                 label="Email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Mail sx={{ color: themeColors.primary }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{ mb: 2 }}
//               />
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Lock sx={{ color: themeColors.primary }} />
//                     </InputAdornment>
//                   ),
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{ mb: 2 }}
//               />
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center',
//                   mb: 2,
//                 }}
//               >
//                 <FormControlLabel
//                   control={<Checkbox />}
//                   label="Remember me"
//                   sx={{ color: themeColors.primary }}
//                 />
//                 <Link href="#" underline="hover" color={themeColors.primary}>
//                   Forgot password?
//                 </Link>
//               </Box>
//               <SignInButton type="submit" fullWidth>
//                 Sign In
//               </SignInButton>
//             </form>
//             <Typography mt={2} align="center" variant="body2">
//               Don’t have an account?{' '}
//               <Link href="/StudentRegister" underline="hover" color={themeColors.primary}>
//                 Sign Up
//               </Link>
//             </Typography>
//           </FormSection>
//           <WelcomeSection>
//             <Typography variant="h4" color="white" fontWeight="bold" mb={2}>
//               Hello Again!
//             </Typography>
//             <Typography variant="body1" color="white" align="center">
//               Join our community of innovators and creators. Your next big opportunity awaits!
//             </Typography>
//           </WelcomeSection>
//         </Box>
//       </StyledPaper>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   Checkbox,
//   FormControlLabel,
//   Link,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   useTheme,
//   useMediaQuery,
// } from '@mui/material';
// import { Visibility, VisibilityOff, Mail, Lock } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';

// const themeColors = {
//   primary: '#9333EA',
//   gradient: 'linear-gradient(90deg, transparent, #9333EA, transparent)',
// };

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   width: '100%',
//   maxWidth: '1200px',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   boxShadow: '0 20px 40px rgba(147, 51, 234, 0.15)',
//   margin: '20px',
//   display: 'flex',
//   flexDirection: 'column',
//   [theme.breakpoints.down('md')]: {
//     margin: '16px',
//   },
// }));

// const FormSection = styled(Box)(({ theme }) => ({
//   flex: 1,
//   padding: '48px',
//   display: 'flex',
//   flexDirection: 'column',
//   gap: '24px',
//   backgroundColor: '#fff',
//   [theme.breakpoints.down('sm')]: {
//     padding: '32px',
//   },
// }));

// const WelcomeSection = styled(Box)(({ theme }) => ({
//   flex: 1,
//   padding: '48px',
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'center',
//   alignItems: 'center',
//   background: themeColors.gradient,
//   [theme.breakpoints.down('md')]: {
//     display: 'none',
//   },
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused': {
//       backgroundColor: '#F9FAFB',
//       '& fieldset': {
//         borderColor: themeColors.primary,
//         borderWidth: '2px',
//       },
//     },
//   },
//   '& .MuiInputLabel-root.Mui-focused': {
//     color: themeColors.primary,
//   },
// }));

// const SignInButton = styled(Button)(({ theme }) => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '14px',
//   borderRadius: '16px',
//   textTransform: 'none',
//   fontSize: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#7E22CE',
//     transform: 'translateY(-2px)',
//     boxShadow: '0 8px 16px rgba(147, 51, 234, 0.2)',
//   },
// }));

// export default function Login() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({ email: '', password: '' });
//   const [error, setError] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.email || !formData.password) {
//       setError('Please fill in all fields.');
//       return;
//     }
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/login/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         const { access, refresh, user_id, username, email, role, user_type } = data;
  
//         // Store data in localStorage
//         localStorage.setItem('authToken', `Bearer ${access}`);
//         localStorage.setItem('refreshToken', `Bearer ${refresh}`);
//         localStorage.setItem('user_id', user_id);
//         localStorage.setItem('username', username);
//         localStorage.setItem('email', email);
//         localStorage.setItem('role', role);
//         localStorage.setItem('user_type', user_type);
  
//         // Navigate based on the role
//         switch (role) {
//           case 'Student':
//             navigate('/StudentApp/');
//             break;
//           case 'Investor':
//             navigate('/InvestorApp/');
//             break;
//           case 'Admin':
//             navigate('/AdminApp/');
//             break;
//           default:
//             navigate('/AdminApp/');
//         }
//       } else if (data.msg === 'This profile has not been approved by the admin') {
//         setError('Your profile is awaiting admin approval. Please check back later.');
//       } else {
//         setError(data.message || 'Login failed. Check your credentials.');
//       }
//     } catch (err) {
//       setError('An error occurred. Please try again later.');
//     }
//   };
  
//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   if (!formData.email || !formData.password) {
//   //     setError('Please fill in all fields.');
//   //     return;
//   //   }
//   //   try {
//   //     const response = await fetch('https://newbackend.elephant-tank.com/api/login/', {
//   //       method: 'POST',
//   //       headers: { 'Content-Type': 'application/json' },
//   //       body: JSON.stringify(formData),
//   //     });
//   //     const data = await response.json();
//   //     if (response.ok) {
//   //       const { access, refresh, user_id, username, email, role, user_type } = data;
  
//   //       // Store data in localStorage
//   //       localStorage.setItem('authToken', `Bearer ${access}`);
//   //       localStorage.setItem('refreshToken', `Bearer ${refresh}`);
//   //       localStorage.setItem('user_id', user_id);
//   //       localStorage.setItem('username', username);
//   //       localStorage.setItem('email', email);
//   //       localStorage.setItem('role', role);
//   //       localStorage.setItem('user_type', user_type);
  
//   //       // Navigate based on the role
//   //       switch (role) {
//   //         case 'Student':
//   //           navigate('/StudentApp/');
//   //           break;
//   //         case 'Investor':
//   //           navigate('/InvestorApp/');
//   //           break;
//   //         case 'Admin':
//   //           navigate('/AdminApp/');
//   //           break;
//   //         default:
//   //           navigate('/AdminApp/');
//   //       }
//   //     } else {
//   //       setError(data.message || 'Login failed. Check your credentials.');
//   //     }
//   //   } catch (err) {
//   //     setError('An error occurred. Please try again later.');
//   //   }
//   // };
  
//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   if (!formData.email || !formData.password) {
//   //     setError('Please fill in all fields.');
//   //     return;
//   //   }
//   //   try {
//   //     const response = await fetch('https://newbackend.elephant-tank.com/api/login/', {
//   //       method: 'POST',
//   //       headers: { 'Content-Type': 'application/json' },
//   //       body: JSON.stringify(formData),
//   //     });
//   //     const data = await response.json();
//   //     if (response.ok) {
//   //       const { access, role } = data;
//   //       localStorage.setItem('authToken', `Bearer ${access}`);
//   //       switch (role) {
//   //         case 'Student':
//   //           navigate('/StudentApp/');
//   //           break;
//   //         case 'Investor':
//   //           navigate('/InvestorApp/');
//   //           break;
//   //         case 'Admin':
//   //           navigate('/AdminApp/');
//   //           break;
//   //         default:
//   //           navigate('/AdminApp/');
//   //       }
//   //     } else {
//   //       setError(data.message || 'Login failed. Check your credentials.');
//   //     }
//   //   } catch (err) {
//   //     setError('An error occurred. Please try again later.');
//   //   }
//   // };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.gradient,
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
//           <FormSection>
//             <Typography variant="h4" fontWeight="bold" mb={1}>
//               Welcome Back!
//             </Typography>
//             <Typography variant="body1" color="text.secondary" mb={2}>
//               Sign in to continue to your account.
//             </Typography>
//             {error && (
//               <Typography color="error" variant="body2" mb={2}>
//                 {error}
//               </Typography>
//             )}
//             <form onSubmit={handleSubmit}>
//               <StyledTextField
//                 fullWidth
//                 label="Email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Mail sx={{ color: themeColors.primary }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{ mb: 2 }}
//               />
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Lock sx={{ color: themeColors.primary }} />
//                     </InputAdornment>
//                   ),
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{ mb: 2 }}
//               />
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center',
//                   mb: 2,
//                 }}
//               >
//                 <FormControlLabel
//                   control={<Checkbox />}
//                   label="Remember me"
//                   sx={{ color: themeColors.primary }}
//                 />
//                 <Link href="#" underline="hover" color={themeColors.primary}>
//                   Forgot password?
//                 </Link>
//               </Box>
//               <SignInButton type="submit" fullWidth>
//                 Sign In
//               </SignInButton>
//             </form>
//             <Typography mt={2} align="center" variant="body2">
//               Don’t have an account?{' '}
//               <Link href="/StudentRegister" underline="hover" color={themeColors.primary}>
//                 Sign Up
//               </Link>
//             </Typography>
//           </FormSection>
//           <WelcomeSection>
//             <Typography variant="h4" color="white" fontWeight="bold" mb={2}>
//               Hello Again!
//             </Typography>
//             <Typography variant="body1" color="white" align="center">
//               Join our community of innovators and creators. Your next big opportunity awaits!
//             </Typography>
//           </WelcomeSection>
//         </Box>
//       </StyledPaper>
//     </Box>
//   );
// }

import React, { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Link,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  Paper,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Visibility, VisibilityOff, Mail, Lock } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Logo1 from '../../src/landpageimage/logo1.png';
import Logo2 from '../../src/landpageimage/TDTLLogo.png';
import Logo3 from '../../src/landpageimage/logo2.jpg';
import Logo4 from '../landpageimage1/DYPLogo.png';
import {  Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

// import WelcomeImage from '../../src/landpageimage/welcome-image.jpg'; // Replace with the path to your image
import p2 from '../../src/landpageimage/pana.png';
const themeColors = {
  primary: '#9333EA',
  gradient: 'linear-gradient(90deg, transparent,rgb(238, 236, 240), transparent)',
};
const MySwal = withReactContent(Swal);

const LogoContainer = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '16px',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  padding: '16px 0',
  marginBottom: '16px',
  '@media (max-width: 600px)': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
}));

const LogoImage = styled('img')(() => ({
  maxWidth: '100px',
  maxHeight: '80px',
  objectFit: 'contain',
  margin: '0 auto',
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  maxWidth: '1200px',
  borderRadius: '24px',
  overflow: 'hidden',
  boxShadow: '0 20px 40px rgba(147, 51, 234, 0.15)',
  margin: '20px',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    margin: '16px',
  },
}));

const FormSection = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: '48px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  backgroundColor: '#fff',
  [theme.breakpoints.down('sm')]: {
    padding: '32px',
  },
}));

const WelcomeSection = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: '48px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  background: themeColors.gradient,
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '16px',
    backgroundColor: '#F3F4F6',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    },
    '&.Mui-focused': {
      backgroundColor: '#F9FAFB',
      '& fieldset': {
        borderColor: themeColors.primary,
        borderWidth: '2px',
      },
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: themeColors.primary,
  },
}));

const SignInButton = styled(Button)(({ theme }) => ({
  backgroundColor: themeColors.primary,
  color: 'white',
  padding: '14px',
  borderRadius: '16px',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: '#7E22CE',
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 16px rgba(147, 51, 234, 0.2)',
  },
}));

export default function Login() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const handleButtonClick = (eventCategory, eventLabel, customAction) => {
    // Log the event for GA
    if (window.gtag) {
      window.gtag('event', 'button_click', {
        event_category: eventCategory,
        event_label: eventLabel,
        value: 1,
      });
    }
  
    // Log the event for GTM
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'button_click',
        event_category: eventCategory,
        event_label: eventLabel,
        value: 1,
      });
    }
  
    // Execute any custom action (e.g., opening dialogs)
    if (typeof customAction === 'function') {
      customAction();
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!formData.email || !formData.password) {
  //     setError('Please fill in all fields.');
  //     return;
  //   }
  //   try {
  //     const response = await fetch('https://newbackend.elephant-tank.com/api/login/', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(formData),
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       const { access, refresh, user_id, username, email, role, user_type } = data;

  //       // Store data in localStorage
  //       localStorage.setItem('authToken', `Bearer ${access}`);
  //       localStorage.setItem('refreshToken', `Bearer ${refresh}`);
  //       localStorage.setItem('user_id', user_id);
  //       localStorage.setItem('username', username);
  //       localStorage.setItem('email', email);
  //       localStorage.setItem('role', role);
  //       localStorage.setItem('user_type', user_type);

  //       // Navigate based on the role
  //       switch (role) {
  //         case 'Student':
  //           navigate('/StudentApp/');
  //           break;
  //         case 'Investor':
  //           navigate('/InvestorApp/');
  //           break;
  //         case 'Admin':
  //           navigate('/AdminApp/');
  //           break;
  //         default:
  //           navigate('/AdminApp/');
  //       }
  //     } else if (data.msg === 'This profile has not been approved ') {
  //       setError('Your profile is awaiting for approval. Please check back later.');
  //     } else {
  //       setError(data.message || 'Login failed. Check your credentials.');
  //     }
  //   } catch (err) {
  //     setError('An error occurred. Please try again later.');
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email || !formData.password) {
      setError('Please fill in all fields.');
      return;
    }

    setLoading(true); // Start the loader

    try {
      const response = await fetch('https://newbackend.elephant-tank.com/api/login/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

      if (response.ok) {
        const { access, refresh, user_id, username, email, role, user_type } = data;

        // Store data in localStorage
        localStorage.setItem('authToken', `Bearer ${access}`);
        localStorage.setItem('refreshToken', `Bearer ${refresh}`);
        localStorage.setItem('user_id', user_id);
        localStorage.setItem('username', username);
        localStorage.setItem('email', email);
        localStorage.setItem('role', role);
        localStorage.setItem('user_type', user_type);

        // Show success alert
        MySwal.fire({
          icon: 'success',
          title: 'Login Successful!',
          text: `Welcome back, ${username}!`,
          timer: 3000,
          showConfirmButton: false,
        });

        // Navigate based on the role
        switch (role) {
          case 'Student':
            navigate('/StudentApp/');
            break;
          case 'Investor':
            navigate('/InvestorApp/');
            break;
          case 'Admin':
            navigate('/AdminApp/');
            break;
          default:
            navigate('/AdminApp/');
        }
      } else if (data.msg === 'This profile has not been approved ') {
        setError('Your profile is awaiting approval. Please check back later.');
      } else {
        MySwal.fire({
          icon: 'error',
          title: 'Login Failed',
          text: data.message || 'Check your credentials and try again.',
        });
      }
    } catch (err) {
      MySwal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred. Please try again later.',
      });
    } finally {
      setLoading(false); // Stop the loader
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: themeColors.gradient,
      }}
    >
      <StyledPaper>
        <LogoContainer>
          <LogoImage src={Logo1} alt="Logo 1" />
          <LogoImage src={Logo2} alt="Logo 2" />
          <LogoImage src={Logo3} alt="Logo 3" />
          <LogoImage src={Logo4} alt="Logo 4" />
        </LogoContainer>
        <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
          <FormSection>
            <Typography variant="h4" fontWeight="bold" mb={1}>
              Welcome Back!
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={2} sx={{ fontWeight: 'bold' }}>
    🎉 It’s time to bring your ideas to life! 🎉
</Typography>

            {error && (
              <Typography color="error" variant="body2" mb={2}>
                {error}
              </Typography>
            )}
            <form onSubmit={handleSubmit}>
              <StyledTextField
                fullWidth
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Mail sx={{ color: themeColors.primary }} />
                    </InputAdornment>
                  ),
                }}
                sx={{ mb: 2 }}
              />
              <StyledTextField
                fullWidth
                label="Password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                value={formData.password}
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock sx={{ color: themeColors.primary }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{ mb: 2 }}
              />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 2,
                }}
              >
                <FormControlLabel
                  control={<Checkbox />}
                  label="Remember me"
                  sx={{ color: themeColors.primary }}
                />
                <Link href="/forgotpassword" underline="hover" color={themeColors.primary}>
                  Forgot password?
                </Link>
              </Box>
              {/* <SignInButton type="submit" fullWidth>
                Sign In
              </SignInButton> */}
              <SignInButton
            type="submit"
            fullWidth
            disabled={loading} 
          >
            {loading ? 'Signing In...' : 'Sign In'} 
          </SignInButton>
            </form>
            <Typography mt={2} align="center" variant="body2">
              Don’t have an account?{' '}
              <Button onClick={() =>
          handleButtonClick(
            'User Actions',
            'CardRegister@ElephantTank',
            () => setOpen(true) // Custom action to open the dialog
          )
        } underline="hover" color={themeColors.primary}>
                Sign Up
              </Button>
              <Dialog
  open={open}
  onClose={() => setOpen(false)}
  fullWidth
  maxWidth="sm" // Restrict max width for smaller screens
  sx={{
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(5, 6, 14, 0.8)', // Solid backdrop color with slight opacity
    },
    '& .MuiPaper-root': {
      borderRadius: '16px',
      padding: '16px',
      backgroundColor: 'white', // Set popup background color to white
    },
  }}
>
  {/* Close Button on Top-Right */}
  <Button
    onClick={() => setOpen(false)}
    sx={{
      position: 'absolute',
      top: 8,
      right: 8,
      minWidth: 'auto',
      color: '#9333EA',

    
    }}
  >
    ✖
  </Button>

  <DialogTitle
    sx={{
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#9333EA',
    }}
  >
    Select Your Role
  </DialogTitle>
  <DialogContent
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' }, // Stack on small screens, row on larger
      justifyContent: 'center', // Align buttons
      alignItems: 'center', // Center items vertically
      gap: 2, // Add spacing between buttons
      px: { xs: 2, sm: 5 }, // Responsive padding
      py: 3,
    }}
  >
    {/* Entrepreneur Button */}
    <Button
      variant="contained"
      size="large"
      // onClick={() => navigate('/StudentRegister')} // Navigate to Entrepreneur route
      onClick={() => 
        handleButtonClick(
          'User Actions',
          'CardRegister@ElephantTank',
          () => navigate('/StudentRegister') // Custom action to open the dialog
        )
      }
      // onClick={() =>
      //   handleButtonClick(
      //     'User Actions',
      //     'CardRegister@ElephantTank',
      //     () => setOpen(true) // Custom action to open the dialog
      //   )
      // }
      sx={{
        background: '#9333EA',
        color: 'white',
        borderRadius: '50px',
        px: 4,
        py: 1.5,
        width: { xs: '100%', sm: 'auto' }, // Full width on small screens
        '&:hover': {
          bgcolor: '#7E22CE',
        },
      }}
    >
      Students & Buding Entrepreneurs
    </Button>

    {/* Investor Button */}
    <Button
      variant="contained"
      size="large"
      // onClick={() => navigate('/invesRegis')} // Navigate to Investor route
      onClick={() => 
        handleButtonClick(
          'User Actions',
          'AngelInvestors&Mentors',
          () => navigate('/invesRegis') // Custom action to open the dialog
        )
      }
      sx={{
        background: '#9333EA',
        color: 'white',
        borderRadius: '50px',
        px: 4,
        py: 1.5,
        width: { xs: '100%', sm: 'auto' }, // Full width on small screens
        '&:hover': {
          bgcolor: '#7E22CE',
        },
      }}
    >
      Angel Investors & Mentors
    </Button>
  </DialogContent>
</Dialog>
            </Typography>
          </FormSection>
          <WelcomeSection>
            <img src={p2} alt="Welcome" style={{ width: '100%', borderRadius: '16px' }} />
          </WelcomeSection>
        </Box>
      </StyledPaper>
    </Box>
  );
}
